import React, { useState, useEffect } from "react";
import { Typography, Button, Box } from "@mui/material";
import { DataGridPro } from '@mui/x-data-grid-pro';
import ReportToolbar from "../ReportToolbar";
import ReportFooter from "../ReportFooter";
import axios from "axios";
import { APIURL } from "../../../config";

export default function BillingTransactionReport(props) {
    const columns = [
        {
            field: "claim_ID",
            headerName: "Claim ID",
            width: 100,
        },
        {
            field: "Payment_Number",
            headerName: "Payment Number",
            width: 100,
        },
        {
            field: "PatientName",
            headerName: "Patient Name",
            width: 150,
        },
        {
            field: "memberMedicaid",
            headerName: "Medicaid ID",
            width: 125,
        },
        {
            field: "priorAuth",
            headerName: "Prior Auth",
            width: 125,
        },
        {
            field: "Service_Date",
            headerName: "Service Date",
            width: 100,
        },
        {
            field: "Deposit_Date",
            headerName: "Deposit Date",
            width: 100,
        },
        {
            field: "Ins_Amount",
            headerName: "Ins Amount",
            width: 100,
        },
        {
            field: "Pat_Amount",
            headerName: "Pat Amount",
            width: 100,
        },
        {
            field: "Adjustment_Reason",
            headerName: "Adjustment Reason",
            width: 200,
        },
    ];

    const rows = props.data.billing.map((claim, index) => {
        const claimDets = {
            id: index,
            claim_ID: claim.Claim_ID,
            Payment_Number: claim.Payment_Number,
            PatientName: claim.Patient_Name,
            memberMedicaid: claim.Medicaid_ID,
            priorAuth: claim.PriorAuth_ID,
            Service_Date: claim.Service_Date,
            Deposit_Date: claim.Deposit_Date,
            Ins_Amount: claim.Ins_Amount,
            Pat_Amount: claim.Pat_Amount,
            Adjustment_Reason: claim.Adjustment_Reason,
        };
        return claimDets;
    });

    const totalRow = {
        id: 'total-row',
        claim_ID: '',
        Payment_Number: '',
        PatientName: '',
        memberMedicaid: '',
        priorAuth: '',
        Service_Date: '',
        Deposit_Date: 'TOTAL:',
        Ins_Amount: props.data.insTotal,
        Pat_Amount: props.data.patTotal,
        Adjustment_Reason: '',
        isTotal: true,
    };

    const CustomToolbar = () => {
        return (
            <ReportToolbar companyName={props.user.company_name} reportTitle="Billing Transaction Report">
                <Box sx={{ pl: 1, pr: 1 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div style={{ fontSize: '16px', fontWeight: 'bold' }}>Transaction Type:</div>
                        <div style={{ fontSize: '16px', fontWeight: 'bold' }}>Report ID:</div>
                    </div>
                    <div style={{ fontSize: '16px', fontWeight: 'bold' }}>Transaction Date: Between {props.data.start} - {props.data.end}</div>
                </Box>
            </ReportToolbar>
        );
    };

    return (
        <div style={{ width: '100%' }}>
            <div style={{ height: '80vh' }}>
                <DataGridPro
                    initialState={{ sorting: { sortModel: [{ field: "Service_Date", sort: "desc" }] } }}
                    getRowId={(row) => row.id}
                    rows={rows}
                    columns={columns}
                    slots={{
                        toolbar: CustomToolbar,
                        footer: ReportFooter
                    }}
                    pinnedRows={{ bottom: [totalRow] }}
                    getRowClassName={(params) => {
                        return params.row.isTotal ? 'total-row' : '';
                    }}
                    sx={{
                        '& .total-row': {
                            backgroundColor: '#f5f5f5',
                            fontWeight: 'bold',
                            borderTop: '2px solid #ddd',
                            '&:hover': {
                                backgroundColor: '#f0f0f0',
                            }
                        }
                    }}
                    checkboxSelection={false}
                    disableRowSelectionOnClick
                    disableVirtualization
                    showToolbar
                />
            </div>
        </div>
    );
}